// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"t0-z","displaySixCardTiles":"u0-z"};